package com.fireavert.properties.shared.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class GetPropertyAdminsResponse(
    val propertyAdmins: List<PropertyAdminResponse>
)
